import type { FaireProductEntity } from "../../entity_types/product";

export const p_yq53fdm79h: FaireProductEntity = {
  token: "p_yq53fdm79h",
  type: "product",
  name: "Egg & Toast It Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/70bc525caa901e30e10935439e03ff90d7035cd48f12c6a851e2283a40247dcb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20671b8f3a78d1fa44a9f2e3853bc39405661cebda68185cbe3e3c177c690c12.jpeg",
    "https://cdn.faire.com/fastly/0b029bee0fbe28a06c1b974a3d42d6ffe3e2bd0abd09890cc9fed08e7f85e121.jpeg"
  ],
  priceDollars: 4,
  description: "Serve up reminders, grocery lists, recipes & more on our Egg & Toast It Sticky Notes. Great for getting organized and bookmarking cookbooks. Breakfast goals. \n\nGood to know: \n\n * Stick & restick anywhere. \n * Measures 3in x 3in \n * 100% Recyclable ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:59.803Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
